module.exports = __webpack_public_path__ + "img/26.c884feae.png";